export default __webpack_public_path__ + "static/media/award.275181f9.svg";